<template>
  <div>
    <div class="grop-news" v-if="terminal == 'PC'">
      <div class="top-menu">
        <div class="top-menu-left">
        </div>
      </div>
      <div class="hezuo" v-if="isshow==true">
        <div class="h-top-box">
          <div class="hezuo-left">
            <p class="hezuo-left-p1">{{ detail.Title }}</p>
            <p class="hezuo-left-p2">{{ detail.briefIntroduction }}</p>
          </div>
          <div class="hezuo-right">
            <img class="hezuo-right-img" :src="imgBaseUrl + detail.ImgUrl" alt="">
          </div>
        </div>
        
        <!--分公司列表静态显示开始-->
        <div>
        <!--1-->
        <div class="ListCard">
         <div  class="card-left1">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">上海福寿园</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Shanghai Fushouyuan</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">上海福壽園</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 400-880-1448
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 400-880-1448
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 400-880-1448
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址:上海市青浦区外青松公路7270弄600号
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address :No. 600, Lane 7270, Waiqingsong Road, Qingpu District, Shanghai 
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址:上海市青浦區外青松公路7270弄600號
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
             <a href="https://www.shfsy.com" target="_blank">www.shfsy.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website :  <a href="https://www.shfsy.com" target="_blank">www.shfsy.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站:  <a href="https://www.shfsy.com" target="_blank">www.shfsy.com</a>
            </div>
        </el-card>
        </div>
        <div  class="card-left2">
          <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">福寿园海港陵园</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Fushouyuan Harbor Cemetery</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title"> 福壽園海港陵園</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 400-821-6869
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 400-821-6869
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 400-821-6869
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址:上海市浦东新区书院镇杞青路1717号
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address :No. 1717 Qiqing Road, Shuyuan Town, Pudong New Area, Shanghai 
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址:上海市浦東新區書院鎮杞青路1717號
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
             <a href="https://www.fsyhgly.com" target="_blank">www.fsyhgly.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website : 
              <a href="https://www.fsyhgly.com" target="_blank">www.fsyhgly.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站: 
              <a href="https://www.fsyhgly.com" target="_blank">www.fsyhgly.com</a>
            </div>
        </el-card>
        </div>
         <div  class="card-left2">
          <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">常州栖凤山福寿园</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Changzhou Qifengshan Fushou Garden</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title"> 常州棲鳳山福壽園</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 400-150-1919
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 400-150-1919
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 400-150-1919
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址:常州市新北区孟河镇346国道西侧栖凤山段1号
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address :No.1 Qifengshan Section, West Side of National Highway 346, Menghe Town, Xinbei District, Changzhou City
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址:常州市新北區孟河鎮346國道西側棲鳳山段1號
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
            <a href="https://www.qifengshan.cn" target="_blank">www.qifengshan.cn</a>
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website : <a href="https://www.qifengshan.cn" target="_blank">www.qifengshan.cn</a>
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站: <a href="https://www.qifengshan.cn" target="_blank">www.qifengshan.cn</a>
            </div>
        </el-card>
        </div>

        </div>
        <!--2-->
        <div class="ListCard">
         <div  class="card-left1">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">上海福寿礼仪</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Shanghai Fushou Etiquette</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">上海福壽禮儀</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 400-821-3050
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 400-821-3050
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 400-821-3050
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址:上海市漕宝路51号\青赵公路1919号\外青松公路7270弄
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address :No. 51 Caobao Road, No. 1919 Qingzhao Road, Lane 7270 Waiqingsong Road, Shanghai
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址:上海市漕寶路51號\青趙公路1919號\外青松公路7270弄
            </div>
                <div class="text item nr_text" v-if="Language==1">
            网站: 
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website : 
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站: 
            </div>
        </el-card>
        </div>
        
       <div  class="card-left2">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">宁波福寿礼仪</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Ningbo Fushou Etiquette</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">寧波福壽禮儀</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 400-811-4004
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 400-811-4004
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 400-811-4004
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址:浙江省宁波市鄞州区钟公庙街道嵩江西路518号
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address :No. 518 Songjiang West Road, Zhonggongmiao Street, Yinzhou District, Ningbo City, Zhejiang Province
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址:浙江省寧波市鄞州區鐘公廟街道嵩江西路518號
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
            <a href="https://nb.fsygroup.com" target="_blank">nb.fsygroup.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website : <a href="https://nb.fsygroup.com" target="_blank">nb.fsygroup.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站: <a href="https://nb.fsygroup.com" target="_blank">nb.fsygroup.com</a>
            </div>
        </el-card>
        </div>

       <div  class="card-left2">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">高邮福寿礼仪</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Gaoyou Blessing and Longevity Etiquette</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">高郵福壽禮儀</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 0514-84477444
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 0514-84477444
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 0514-84477444
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址:江苏省扬州市高邮市城南经济开发区地震台路 
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address :Seismic Station Road, Chengnan Economic Development Zone, Gaoyou City, Yangzhou City, Jiangsu Province
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址:江蘇省揚州市高郵市城南經濟開發區地震臺路
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
            
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website : 
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站:  
            </div>
        </el-card>
        </div>

        </div>
        <!--3-->
        <div class="ListCard">
         <div  class="card-left1">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">大丰福寿礼仪</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Dafeng Blessing and Longevity Etiquette</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">大豐福壽禮儀</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 0515-83334444
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 0515-83334444
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 0515-83334444
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址: 江苏省盐城市大丰区人民北路417号（阜北村6组）
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address :417 Renmin North Road, Dafeng District, Yancheng City, Jiangsu Province (Group 6, Fubei Village)
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址:江蘇省鹽城市大豐區人民北路417號（阜北村6組）
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
             
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website : 
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站:  
            </div>
        </el-card>
        </div>
        
       <div  class="card-left2">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">金坛福寿礼仪</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Jintan Blessing and Longevity Etiquette</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">金壇福壽禮儀</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 0519-82844666
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 0519-82844666
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 0519-82844666
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址:江苏省常州市金坛区丹阳门北路300号
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address :300 Danyangmen North Road, Jintan District, Changzhou City, Jiangsu Province
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址:江蘇省常州市金壇區丹陽門北路300號
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
          
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website : 
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站: 
            </div>
        </el-card>
        </div>

       <div  class="card-left2">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">合肥大蜀山文化陵园</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Hefei Dashushan Cultural Cemetery</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">合肥大蜀山文化陵園</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 0551-65382977
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 0551-65382977
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 0551-65382977
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址:合肥市蜀山区环山西路（大蜀山森林公园西侧）
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address :Huanshan West Road, Shushan District, Hefei City (west of Dashushan Forest Park)
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址:合肥市蜀山區環山西路（大蜀山森林公園西側）
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
             <a href="https://hfdss.fsygroup.com/" target="_blank">hfdss.fsygroup.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website : <a href="https://hfdss.fsygroup.com/" target="_blank">hfdss.fsygroup.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站: <a href="https://hfdss.fsygroup.com/" target="_blank">hfdss.fsygroup.com</a>
            </div>
        </el-card>
        </div>

        </div>
         <!--4-->
        <div class="ListCard">
         <div  class="card-left1">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">南昌福寿园</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Nanchang Fushou Garden</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">南昌福壽園</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 400-607-9178
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 400-607-9178
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 400-607-9178
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址:江西省南昌市新建区西山镇西山村
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address :Xishan Village, Xishan Town, Xinjian District, Nanchang City, Jiangxi Province
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址:江西省南昌市新建區西山鎮西山村
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
             <a href="https://jx.fsygroup.com/" target="_blank">jx.fsygroup.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website :  <a href="https://jx.fsygroup.com/" target="_blank">jx.fsygroup.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站: <a href="https://jx.fsygroup.com/" target="_blank">jx.fsygroup.com</a>
            </div>
        </el-card>
        </div>
        
       <div  class="card-left2">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">梅岭世纪园</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Meiling Century Park</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">梅嶺世紀園</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 400-607-9178
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 400-607-9178
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 400-607-9178
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址:江西省南昌市新建区七彩路东
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address :East of Qicai Road, Xinjian District, Nanchang City, Jiangxi Province
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址:江西省南昌市新建區七彩路東
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
             <a href="https://jx.fsygroup.com/" target="_blank">jx.fsygroup.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website : <a href="https://jx.fsygroup.com/" target="_blank">jx.fsygroup.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站: <a href="https://jx.fsygroup.com/" target="_blank">jx.fsygroup.com</a>
            </div>
        </el-card>
        </div>

       <div  class="card-left2">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">赣州蓉龙人文纪念园</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Ganzhou Ronglong Humanistic Memorial Park</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">贛州蓉龍人文紀念園</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 400-830-1448
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 400-830-1448
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 400-830-1448
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址: 江西省赣州蓉江新区潭东镇茶元村
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address : Chayuan Village, Tandong Town, Rongjiang New District, Ganzhou, Jiangxi Province
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址: 江西省贛州蓉江新區潭東鎮茶元村
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
             <a href="https://jxgz.fsygroup.com/" target="_blank">jxgz.fsygroup.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website : <a href="https://jxgz.fsygroup.com/" target="_blank">jxgz.fsygroup.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站: <a href="https://jxgz.fsygroup.com/" target="_blank">jxgz.fsygroup.com</a>
            </div>
        </el-card>
        </div>

        </div>
         <!--5-->
        <div class="ListCard">
         <div  class="card-left1">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">淮北福寿园</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Huaibei Fushou Garden</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">淮北福壽園</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 0561-3080408
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 0561-3080408
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 0561-3080408
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址:安徽省淮北市杜集区方山路 
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address :Fangshan Road, Duji District, Huaibei City, Anhui Province
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址:安徽省淮北市杜集區方山路
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
             <a href="http://www.huaibeifsy.com/" target="_blank">www.huaibeifsy.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website :<a href="http://www.huaibeifsy.com/" target="_blank">www.huaibeifsy.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站:<a href="http://www.huaibeifsy.com/" target="_blank">www.huaibeifsy.com</a>
            </div>
        </el-card>
        </div>
        
       <div  class="card-left2">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">宿州龙门福寿园</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Suzhou Longmen Fushou Garden</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">宿州龍門福壽園</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 400-612-2808
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 400-612-2808
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話:400-612-2808 
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址:宿州市埇桥区符离镇褚庄村北800米（206国道旁）
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address :800 meters north of Chuzhuang Village, Fuli Town, Yongqiao District, Suzhou City (next to National Highway 206)
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址:宿州市埇橋區符離鎮褚莊村北800米（206國道旁
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website :
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站:
            </div>
        </el-card>
        </div>

       <div  class="card-left2">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">宣城马山风景陵园</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Xuancheng Mashan Scenic Cemetery</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">宣城馬山風景陵園</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 0563-2022586
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 0563-2022586
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 0563-2022586
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址:宣城市宣州区养贤乡大山庵村 
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address :Dashan'an Village, Yangxian Township, Xuanzhou District, Xuancheng City
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址:宣城市宣州區養賢鄉大山庵村
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
           
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website :  
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站: 
            </div>
        </el-card>
        </div>

        </div>
         <!--6-->
        <div class="ListCard">
         <div  class="card-left1">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">湖北天圣园</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Hubei Tiansheng Garden</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">湖北天聖園</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 0728-4586144
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 0728-4586144
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 0728-4586144
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址:湖北省天门市多祥镇天门南站旁900米
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address :900 meters away from Tianmen South Station, Duoxiang Town, Tianmen City, Hubei Province
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址:湖北省天門市多祥鎮天門南站旁900米
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
             <a href="http://www.fsytsy.com" target="_blank">www.fsytsy.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website :<a href="http://www.fsytsy.com" target="_blank">www.fsytsy.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站:<a href="http://www.fsytsy.com" target="_blank">www.fsytsy.com</a>
            </div>
        </el-card>
        </div>
        
       <div  class="card-left2">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">合肥人本殡葬服务</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Hefei Humanistic Funeral Services</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">合肥人本殯葬服務</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 0551-962444
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 0551-962444
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 0551-962444
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址:安徽省合肥市蜀山区合作化北路153号殡仪馆宿舍F区301 
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address:Room 301, Block F, Funeral Parlor Dormitory, No. 153 Hezuo North Road, Shushan District, Hefei City, Anhui Province
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址:安徽省合肥市蜀山區合作化北路153號殯儀館宿舍F區301
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站:<a href="http://www.hfrbbz.com" target="_blank">www.hfrbbz.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website :<a href="http://www.hfrbbz.com" target="_blank">www.hfrbbz.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站: <a href="http://www.hfrbbz.com" target="_blank">www.hfrbbz.com</a>
            </div>
        </el-card>
        </div>

       <div  class="card-left2">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">瑞昌福寿礼仪</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Ruichang Blessing and Longevity Etiquette</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">瑞昌福壽禮儀</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 0792-4232123
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 0792-4232123
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 0792-4232123
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址: 江西省九江市瑞昌市人民北路138号
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address :No. 138 Renmin North Road, Ruichang City, Jiujiang City, Jiangxi Province
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址: 江西省九江市瑞昌市人民北路138號
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website : 
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站: 
            </div>
        </el-card>
        </div>

        </div>
         <!--7-->
        <div class="ListCard">
         <div  class="card-left1">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">庐江福寿礼仪</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Lujiang Blessing and Longevity Etiquette</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">廬江福壽禮儀</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 0551-87771414
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 0551-87771414
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 0551-87771414
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址:安徽省庐江县庐城镇庐白路123号 
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address :No. 123 Lubai Road, Lucheng Town, Lujiang County, Anhui Province
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址:安徽省廬江縣廬城鎮廬白路123號
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website :
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站:
            </div>
        </el-card>
        </div>
        
       <div  class="card-left2">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">巢湖福寿礼仪</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Chaohu Blessing and Longevity Etiquette</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">巢湖福壽禮儀</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 0551-82323234
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 0551-82323234
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 0551-82323234
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址:安徽省巢湖市夏阁镇殷家山路1号
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address :No.1 Yinjiashan Road, Xiage Town, Chaohu City, Anhui Province
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址:安徽省巢湖市夏閣鎮殷家山路1號
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website :
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站:
            </div>
        </el-card>
        </div>

       <div  class="card-left2">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">舒城福寿礼仪</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Shucheng Blessing and Longevity Etiquette</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">舒城福壽禮儀</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话:0564-962444 
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 0564-962444
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 0564-962444
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址:安徽省六安市舒城县城关镇马河口镇幸福村舒城殡仪馆
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address :Shucheng Funeral Parlor, Xingfu Village, Mahekou Town, Chengguan Town, Shucheng County, Lu'an City, Anhui Province
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址:安徽省六安市舒城縣城關鎮馬河口鎮幸福村舒城殯儀館
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website :
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站:
            </div>
        </el-card>
        </div>

        </div>
         <!--8-->
        <div class="ListCard">
         <div  class="card-left1">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">兰州福寿园</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Lanzhou Fushou Garden</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">蘭州福壽園</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 0931-2345345
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone:0931-2345345
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 0931-2345345
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址: 兰州市七里河区沈家岭100号
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address :No. 100 Shenjialing, Qilihe District, Lanzhou City
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址:蘭州市七裡河區沈家嶺100號
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website :
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站: 
            </div>
        </el-card>
        </div>
        
       <div  class="card-left2">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">重庆白塔福寿园</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Chongqing Baita Fushou Garden</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">重慶白塔福壽園</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 023-49888888 
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 023-49888888
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 023-49888888
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址:重庆市永川区南大街新泰路269号 
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address :No. 269 Xintai Road, South Street, Yongchuan District, Chongqing
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址:重慶市永川區南大街新泰路269號
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
             <a href="https://cqyc.fsygroup.com/" target="_blank">cqyc.fsygroup.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website :  <a href="https://cqyc.fsygroup.com/" target="_blank">cqyc.fsygroup.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站:  <a href="https://cqyc.fsygroup.com/" target="_blank">cqyc.fsygroup.com</a>
            </div>
        </el-card>
        </div>

       <div  class="card-left2">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">重庆西郊福寿园</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Fushou Garden in the western suburbs of Chongqing</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">重慶西郊福壽園</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 400-860-1448 
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 400-860-1448 
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 400-860-1448
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址:重庆市璧山区河边镇复兴村3组 
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address :Group 3, Fuxing Village, Hebian Town, Bishan District, Chongqing City
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址:重慶市璧山區河邊鎮復興村3組
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
             <a href="http://www.cqxjfsy.com/" target="_blank">www.cqxjfsy.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website :  <a href="http://www.cqxjfsy.com/" target="_blank">www.cqxjfsy.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站:  <a href="http://www.cqxjfsy.com/" target="_blank">www.cqxjfsy.com</a>
            </div>
        </el-card>
        </div>

        </div>
         <!--9-->
        <div class="ListCard">
         <div  class="card-left1">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">重庆南山福座陵园</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Chongqing Nanshan Fuzuo Cemetery</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">重慶南山福座陵園</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 023-62752338
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 023-62752338
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 023-62752338
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址:重庆市南岸区四公里光黔路80号江南殡仪馆右侧
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address :Right side of Jiangnan Funeral Parlor, No. 80 Guangqian Road, Nan'an District, Chongqing
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址:重慶市南岸區四公里光黔路80號江南殯儀館右側
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
             <a href="https://cqns.fsygroup.com/" target="_blank">cqns.fsygroup.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website :  <a href="https://cqns.fsygroup.com/" target="_blank">cqns.fsygroup.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站:  <a href="https://cqns.fsygroup.com/" target="_blank">cqns.fsygroup.com</a>
            </div>
        </el-card>
        </div>
        
       <div  class="card-left2">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">钦州华祖园</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Qinzhou Huazu Garden</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">欽州華祖園</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 400-100-8911
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 400-100-8911
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 400-100-8911
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址: 钦州市钦北区大垌镇歌标村
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address :Gebiao Village, Dadong Town, Qinbei District, Qinzhou City
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址:欽州市欽北區大垌鎮歌標村
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
             <a href="https://gxqz.fsygroup.com/" target="_blank">gxqz.fsygroup.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website :  <a href="https://gxqz.fsygroup.com/" target="_blank">gxqz.fsygroup.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站:  <a href="https://gxqz.fsygroup.com/" target="_blank">gxqz.fsygroup.com</a>
            </div>
        </el-card>
        </div>

       <div  class="card-left2">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">广西华祖园</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Guangxi Huazu Garden</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">廣西華祖園</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 400-100-8911
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 400-100-8911
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 400-100-8911
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址:防城港市防城区三波村 
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address : Sanbo Village, Fangcheng District, Fangchenggang City
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址: 防城港市防城區三波村
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
             <a href="https://gxfcg.fsygroup.com/" target="_blank">gxfcg.fsygroup.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website :  <a href="https://gxfcg.fsygroup.com/" target="_blank">gxfcg.fsygroup.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站:  <a href="https://gxfcg.fsygroup.com/" target="_blank">gxfcg.fsygroup.com</a>
            </div>
        </el-card>
        </div>

        </div>
         <!--10-->
        <div class="ListCard">
         <div  class="card-left1">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">延安洪福公墓有限公司</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Yan'an Hongfu Cemetery Co., Ltd</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">延安洪福公墓有限公司</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 0911-8810777
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 0911-8810777
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 0911-8810777
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址:陕西省延安市宝塔区万花山镇前锁崖村归厚路后山 
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address :Behind Guihou Road, Qiansuoya Village, Wanhuashan Town, Baota District, Yan'an City, Shaanxi Province
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址:陝西省延安市寶塔區萬花山鎮前鎖崖村歸厚路後山
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website :
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站: 
            </div>
        </el-card>
        </div>
        
       <div  class="card-left2">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">金沙福寿园</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Jinsha Fushou Garden</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">金沙福壽園</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 0857-7212444
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 0857-7212444
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 0857-7212444
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址:贵州省毕节市金沙县五龙街道新光组大竹林南侧 
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address :South of Dazhulin, Xinguang Formation, Wulong Street, Jinsha County, Bijie City, Guizhou Province
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址:貴州省畢節市金沙縣五龍街道新光組大竹林南側
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
             <a href="https://gzjs.fsygroup.com/" target="_blank">gzjs.fsygroup.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website :  <a href="https://gzjs.fsygroup.com/" target="_blank">gzjs.fsygroup.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站:  <a href="https://gzjs.fsygroup.com/" target="_blank">gzjs.fsygroup.com</a>
            </div>
        </el-card>
        </div>

       <div  class="card-left2">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">正安福寿园</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Zheng'an Fushou Garden</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">正安福壽園</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 0851-28762777 
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 0851-28762777
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 0851-28762777
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址:贵州省遵义市正安县凤仪街道楼台村大山组
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address :Dashan Group, Loutai Village, Fengyi Street, Zheng'an County, Zunyi City, Guizhou Province
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址:貴州省遵義市正安縣鳳儀街道樓臺村大山組
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website :
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站:
            </div>
        </el-card>
        </div>

        </div>
         <!--11-->
        <div class="ListCard">
         <div  class="card-left1">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">重庆安乐生命纪念馆</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Chongqing Anle Life Memorial Hall</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">重慶安樂生命紀念館</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 400-023-8484 
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 400-023-8484 
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 400-023-8484
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址: 重庆市渝中区长滨路341号
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address : No. 341 Changbin Road, Yuzhong District, Chongqing
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址: 重慶市渝中區長濱路341號
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
             <a href="https://cq.fsygroup.com/" target="_blank">cq.fsygroup.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website :  <a href="https://cq.fsygroup.com/" target="_blank">cq.fsygroup.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站:  <a href="https://cq.fsygroup.com/" target="_blank">cq.fsygroup.com</a>
            </div>
        </el-card>
        </div>
        
       <div  class="card-left2">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">重庆新桥安乐堂</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Chongqing Xinqiao Anle Hall</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">重慶新橋安樂堂</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 400-023-8484
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 400-023-8484
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 400-023-8484
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址: 重庆沙坪坝区新桥村石壁山3号
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address :No.3 Shibishan, Xinqiao Village, Shapingba District, Chongqing
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址:重慶沙坪壩區新橋村石壁山3號
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
             <a href="https://cq.fsygroup.com/" target="_blank">cq.fsygroup.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website :  <a href="https://cq.fsygroup.com/" target="_blank">cq.fsygroup.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站:  <a href="https://cq.fsygroup.com/" target="_blank">cq.fsygroup.com</a>
            </div>
        </el-card>
        </div>

       <div  class="card-left2">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">辽宁观陵山福寿园</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Liaoning Guanling Mountain Fushou Garden</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">遼寧觀陵山福壽園</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 400-886-1448 
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 400-886-1448 
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 400-886-1448
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址:辽宁省铁岭市铁岭县横道河子镇 
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address :Hengdaohezi Town, Tieling County, Tieling City, Liaoning Province
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址:遼寧省鐵嶺市鐵嶺縣橫道河子鎮
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
             <a href="http://www.gls024.com" target="_blank">www.gls024.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website :  <a href="http://www.gls024.com" target="_blank">www.gls024.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站:  <a href="http://www.gls024.com" target="_blank">www.gls024.com</a>
            </div>
        </el-card>
        </div>

        </div>
         <!--12-->
        <div class="ListCard">
         <div  class="card-left1">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">哈尔滨福寿园</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Harbin Fushou Garden</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">哈爾濱福壽園</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 400-055-7058
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 400-055-7058
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 400-055-7058
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址:黑龙江省哈尔滨市宾县二龙山
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address :Erlongshan Mountain, Bin County, Harbin City, Heilongjiang Province
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址:黑龍江省哈爾濱市賓縣二龍山
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
             <a href="https://hrb.fsygroup.com/" target="_blank">hrb.fsygroup.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website :  <a href="https://hrb.fsygroup.com/" target="_blank">hrb.fsygroup.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站:  <a href="https://hrb.fsygroup.com/" target="_blank">hrb.fsygroup.com</a>
            </div>
        </el-card>
        </div>
        
       <div  class="card-left2">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">锦州帽山福寿园</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Jinzhou Maoshan Fushou Garden</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">錦州帽山福壽園</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 400-004-8099
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 400-004-8099
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 400-004-8099
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址: 辽宁省锦州市古塔区钟屯乡帽山村南
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address :Maoshan Village South, Zhongtun Township, Guta District, Jinzhou City, Liaoning Province
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址:遼寧省錦州市古塔區鐘屯鄉帽山村南
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
             <a href="https://lnjz.fsygroup.com" target="_blank">lnjz.fsygroup.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website :  <a href="https://lnjz.fsygroup.com" target="_blank">lnjz.fsygroup.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站:  <a href="https://lnjz.fsygroup.com" target="_blank">lnjz.fsygroup.com</a>
            </div>
        </el-card>
        </div>

       <div  class="card-left2">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">内蒙古福寿园</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Inner Mongolia Fushouyuan</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">內蒙古福壽園</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 0471-7260111
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 0471-7260111
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 0471-7260111
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址: 内蒙古呼和浩特市盛乐经济园区保尔此老村
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address :Baoerqi Old Village, Shengle Economic Park, Hohhot City, Inner Mongolia
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址:內蒙古呼和浩特市盛樂經濟園區保爾此老村
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
             <a href="http://www.nmgfsy.com/" target="_blank">www.nmgfsy.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website :  <a href="http://www.nmgfsy.com/" target="_blank">www.nmgfsy.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站:  <a href="http://www.nmgfsy.com/" target="_blank">www.nmgfsy.com</a>
            </div>
        </el-card>
        </div>

        </div>
         <!--13-->
        <div class="ListCard">
         <div  class="card-left1">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">朝阳龙山福寿园</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Chaoyang Longshan Fushou Garden</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">朝陽龍山福壽園</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 0421-2578399
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 0421-2578399
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 0421-2578399
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址:朝阳县柳城街道波赤村
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address :Bochi Village, Liucheng Street, Chaoyang County
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址:朝陽縣柳城街道波赤村
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
             <a href="http://www.cyxlsfy.com" target="_blank">www.cyxlsfy.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website :<a href="http://www.cyxlsfy.com" target="_blank">www.cyxlsfy.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站:<a href="http://www.cyxlsfy.com" target="_blank">www.cyxlsfy.com</a>
            </div>
        </el-card>
        </div>
        
       <div  class="card-left2">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">涿鹿元宝山</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Zhuolu Yuanbao Mountain</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">涿鹿元寶山</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 15011597118 
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 15011597118
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 15011597118
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址:河北省张家口市涿鹿县卧佛寺镇太平堡村 
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address :Taipingbao Village, Wofosi Town, Zhuolu County, Zhangjiakou City, Hebei Province
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址:河北省張家口市涿鹿縣臥佛寺鎮太平堡村
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website :
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站:
            </div>
        </el-card>
        </div>

       <div  class="card-left2">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">沈阳福佑礼仪</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Shenyang Fuyou Etiquette</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">瀋陽福佑禮儀</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 400-609-6144
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 400-609-6144
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 400-609-6144
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址:辽宁省沈阳市浑南区孙家寨路99号
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address :No. 99 Sunjiazhai Road, Hunnan District, Shenyang City, Liaoning Province
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址:遼寧省瀋陽市渾南區孫家寨路99號
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website :
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站:  
            </div>
        </el-card>
        </div>

        </div>
         <!--14-->
        <div class="ListCard">
         <div  class="card-left1">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">河南福寿园</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Henan Fushouyuan</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">河南福壽園</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 400-666-3453
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 400-666-3453
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 400-666-3453
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址:河南省郑州市新郑龙湖镇双梅路1号
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address : No.1 Shuangmei Road, Longhu Town, Xinzheng, Zhengzhou City, Henan Province
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址: 河南省鄭州市新鄭龍湖鎮雙梅路1號
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
            <a href="https://hn.fsygroup.com/" target="_blank">hn.fsygroup.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website :<a href="https://hn.fsygroup.com/" target="_blank">hn.fsygroup.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站:<a href="https://hn.fsygroup.com/" target="_blank">hn.fsygroup.com</a>
            </div>
        </el-card>
        </div>
        
       <div  class="card-left2">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">山东福寿园</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Shandong Fushouyuan</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">山東福壽園</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 400-658-6779
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 400-658-6779
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 400-658-6779
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址:山东省济南市长清区孝里街道龙泉官庄村南
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address : South of Longquan Guanzhuang Village, Xiaoli Street, Changqing District, Jinan City, Shandong Province
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址: 山東省濟南市長清區孝裏街道龍泉官莊村南
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
             <a href="http://www.sdfsy.com" target="_blank">www.sdfsy.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website :<a href="http://www.sdfsy.com" target="_blank">www.sdfsy.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站: <a href="http://www.sdfsy.com" target="_blank">www.sdfsy.com</a>
            </div>
        </el-card>
        </div>

       <div  class="card-left2">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">洛阳仙鹤福寿园</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Luoyang Xianhe Fushou Garden</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">洛陽仙鶴福壽園</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 400-811-8986
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 400-811-8986
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 400-811-8986
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址: 河南省洛阳市伊川县河滨街道办事处小庄社区168号
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address : No. 168, Xiaozhuang Community, Hebin Street Office, Yichuan County, Luoyang City, Henan Province
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址: 河南省洛陽市伊川縣河濱街道辦事處小莊社區168號
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
             <a href="https://ly.fsygroup.com/" target="_blank">ly.fsygroup.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website :  <a href="https://ly.fsygroup.com/" target="_blank">ly.fsygroup.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站:  <a href="https://ly.fsygroup.com/" target="_blank">ly.fsygroup.com</a>
            </div>
        </el-card>
        </div>

        </div>
         <!--15-->
        <div class="ListCard">
         <div  class="card-left1">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">安阳福寿园</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Anyang Fushou Garden</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">安陽福壽園</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 0372-5563444
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 0372-5563444
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 0372-5563444
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址:河南省安阳市殷都区洪河屯乡西五龙沟村 
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address :Xiwulonggou Village, Honghetun Township, Yindu District, Anyang City, Henan Province
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址:河南省安陽市殷都區洪河屯鄉西五龍溝村
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
             <a href="https://hnay.fsygroup.com/" target="_blank">hnay.fsygroup.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website :  <a href="https://hnay.fsygroup.com/" target="_blank">hnay.fsygroup.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站:  <a href="https://hnay.fsygroup.com/" target="_blank">hnay.fsygroup.com</a>
            </div>
        </el-card>
        </div>
        
       <div  class="card-left2">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">泰安福寿礼仪</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Tai'an Blessing and Longevity Etiquette</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">泰安福壽禮儀</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 0538-8578144
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 0538-8578144
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 0538-8578144
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址:山东省泰安市岱岳区粥店办事处六郎坟村西
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address :West of Liulangfen Village, Congee Office, Daiyue District, Tai'an City, Shandong Province
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址: 山東省泰安市岱岳區粥店辦事處六郎墳村西
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website : 
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站:
            </div>
        </el-card>
        </div>

       <div  class="card-left2">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">菏泽福寿园</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Heze Fushou Garden</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">菏澤福壽園</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 0530-6264466
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 0530-6264466
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 0530-6264466
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址:菏泽市鲁西新区吕陵镇政府以西1.5公里 
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address :1.5 kilometers west of Luling Town Government in Luxi New District, Heze City
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址:菏澤市魯西新區呂陵鎮政府以西1.5公里
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website :
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站:
            </div>
        </el-card>
        </div>

        </div>
         <!--16-->
        <div class="ListCard">
         <div  class="card-left1">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">安尊福寿园</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Anzhun Fushou Garden</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">安尊福壽園</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 0534-5953888
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 0534-5953888
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 0534-5953888
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址:山东省德州市齐河县华店镇齐河人文纪念公园东400米
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address :400 meters east of Qihe Humanistic Memorial Park, Huadian Town, Qihe County, Dezhou City, Shandong Province
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址:山東省德州市齊河縣華店鎮齊河人文紀念公園東400米
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website : 
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站: 
            </div>
        </el-card>
        </div>
        
       <div  class="card-left2">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">郑州福寿礼仪</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Zhengzhou Fushou Etiquette</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">鄭州福壽禮儀</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 400-666-3443
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 400-666-3443
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 400-666-3443
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址:河南省郑州市中原区西三环与航海路交叉口向南600米路西
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address : 600 meters south of the intersection of West Third Ring Road and Hanghai Road in Zhongyuan District, Zhengzhou City, Henan Province, west of the road
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址: 河南省鄭州市中原區西三環與航海路交叉口向南600米路西
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website : 
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站:  
            </div>
        </el-card>
        </div>

        </div>
        </div>
    </div> 
    </div>
    <div v-if="terminal == 'Mobile'">
      <div class="mobile-hezuo" v-if="isshow==true">
        <div class="mobile-hezuo-box">
          <img class="mobile-hezuo-right-img" :src="imgBaseUrl + detail.ImgUrl" alt="">
          <div class="mobile-hezuo-bottom">
            <p class="mobile-hezuo-p1">{{ detail.Title }}</p>
            <p class="mobile-hezuo-p2">{{ detail.briefIntroduction }}</p>
          </div>
 <!--分公司列表静态显示开始-->
        <div>
        <!--1-->
        <div class="ListCard">
         <div  class="card-left1_m">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">上海福寿园</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Shanghai Fushouyuan</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">上海福壽園</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 400-880-1448
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 400-880-1448
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 400-880-1448
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址:上海市青浦区外青松公路7270弄600号
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address :No. 600, Lane 7270, Waiqingsong Road, Qingpu District, Shanghai 
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址:上海市青浦區外青松公路7270弄600號
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
             <a href="https://www.shfsy.com" target="_blank">www.shfsy.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website :  <a href="https://www.shfsy.com" target="_blank">www.shfsy.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站:  <a href="https://www.shfsy.com" target="_blank">www.shfsy.com</a>
            </div>
        </el-card>
        </div>
        <div  class="card-left2_m">
          <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">福寿园海港陵园</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Fushouyuan Harbor Cemetery</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title"> 福壽園海港陵園</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 400-821-6869
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 400-821-6869
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 400-821-6869
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址:上海市浦东新区书院镇杞青路1717号
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address :No. 1717 Qiqing Road, Shuyuan Town, Pudong New Area, Shanghai 
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址:上海市浦東新區書院鎮杞青路1717號
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
             <a href="https://www.fsyhgly.com" target="_blank">www.fsyhgly.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website : 
              <a href="https://www.fsyhgly.com" target="_blank">www.fsyhgly.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站: 
              <a href="https://www.fsyhgly.com" target="_blank">www.fsyhgly.com</a>
            </div>
        </el-card>
        </div>
         <div  class="card-left2_m">
          <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">常州栖凤山福寿园</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Changzhou Qifengshan Fushou Garden</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title"> 常州棲鳳山福壽園</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 400-150-1919
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 400-150-1919
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 400-150-1919
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址:常州市新北区孟河镇346国道西侧栖凤山段1号
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address :No.1 Qifengshan Section, West Side of National Highway 346, Menghe Town, Xinbei District, Changzhou City
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址:常州市新北區孟河鎮346國道西側棲鳳山段1號
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
            <a href="https://www.qifengshan.cn" target="_blank">www.qifengshan.cn</a>
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website : <a href="https://www.qifengshan.cn" target="_blank">www.qifengshan.cn</a>
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站: <a href="https://www.qifengshan.cn" target="_blank">www.qifengshan.cn</a>
            </div>
        </el-card>
        </div>

        </div>
        <!--2-->
        <div class="ListCard">
         <div  class="card-left1_m">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">上海福寿礼仪</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Shanghai Fushou Etiquette</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">上海福壽禮儀</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 400-821-3050
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 400-821-3050
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 400-821-3050
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址:上海市漕宝路51号\青赵公路1919号\外青松公路7270弄
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address :No. 51 Caobao Road, No. 1919 Qingzhao Road, Lane 7270 Waiqingsong Road, Shanghai
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址:上海市漕寶路51號\青趙公路1919號\外青松公路7270弄
            </div>
                <div class="text item nr_text" v-if="Language==1">
            网站: 
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website : 
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站: 
            </div>
        </el-card>
        </div>
        
       <div  class="card-left2_m">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">宁波福寿礼仪</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Ningbo Fushou Etiquette</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">寧波福壽禮儀</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 400-811-4004
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 400-811-4004
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 400-811-4004
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址:浙江省宁波市鄞州区钟公庙街道嵩江西路518号
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address :No. 518 Songjiang West Road, Zhonggongmiao Street, Yinzhou District, Ningbo City, Zhejiang Province
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址:浙江省寧波市鄞州區鐘公廟街道嵩江西路518號
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
            <a href="https://nb.fsygroup.com" target="_blank">nb.fsygroup.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website : <a href="https://nb.fsygroup.com" target="_blank">nb.fsygroup.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站: <a href="https://nb.fsygroup.com" target="_blank">nb.fsygroup.com</a>
            </div>
        </el-card>
        </div>

       <div  class="card-left2_m">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">高邮福寿礼仪</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Gaoyou Blessing and Longevity Etiquette</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">高郵福壽禮儀</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 0514-84477444
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 0514-84477444
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 0514-84477444
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址:江苏省扬州市高邮市城南经济开发区地震台路 
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address :Seismic Station Road, Chengnan Economic Development Zone, Gaoyou City, Yangzhou City, Jiangsu Province
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址:江蘇省揚州市高郵市城南經濟開發區地震臺路
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
            
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website : 
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站:  
            </div>
        </el-card>
        </div>

        </div>
        <!--3-->
        <div class="ListCard">
         <div  class="card-left1_m">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">大丰福寿礼仪</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Dafeng Blessing and Longevity Etiquette</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">大豐福壽禮儀</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 0515-83334444
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 0515-83334444
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 0515-83334444
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址: 江苏省盐城市大丰区人民北路417号（阜北村6组）
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address :417 Renmin North Road, Dafeng District, Yancheng City, Jiangsu Province (Group 6, Fubei Village)
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址:江蘇省鹽城市大豐區人民北路417號（阜北村6組）
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
             
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website : 
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站:  
            </div>
        </el-card>
        </div>
        
       <div  class="card-left2_m">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">金坛福寿礼仪</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Jintan Blessing and Longevity Etiquette</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">金壇福壽禮儀</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 0519-82844666
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 0519-82844666
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 0519-82844666
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址:江苏省常州市金坛区丹阳门北路300号
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address :300 Danyangmen North Road, Jintan District, Changzhou City, Jiangsu Province
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址:江蘇省常州市金壇區丹陽門北路300號
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
          
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website : 
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站: 
            </div>
        </el-card>
        </div>

       <div  class="card-left2_m">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">合肥大蜀山文化陵园</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Hefei Dashushan Cultural Cemetery</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">合肥大蜀山文化陵園</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 0551-65382977
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 0551-65382977
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 0551-65382977
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址:合肥市蜀山区环山西路（大蜀山森林公园西侧）
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address :Huanshan West Road, Shushan District, Hefei City (west of Dashushan Forest Park)
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址:合肥市蜀山區環山西路（大蜀山森林公園西側）
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
             <a href="https://hfdss.fsygroup.com/" target="_blank">hfdss.fsygroup.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website : <a href="https://hfdss.fsygroup.com/" target="_blank">hfdss.fsygroup.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站: <a href="https://hfdss.fsygroup.com/" target="_blank">hfdss.fsygroup.com</a>
            </div>
        </el-card>
        </div>

        </div>
         <!--4-->
        <div class="ListCard">
         <div  class="card-left1_m">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">南昌福寿园</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Nanchang Fushou Garden</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">南昌福壽園</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 400-607-9178
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 400-607-9178
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 400-607-9178
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址:江西省南昌市新建区西山镇西山村
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address :Xishan Village, Xishan Town, Xinjian District, Nanchang City, Jiangxi Province
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址:江西省南昌市新建區西山鎮西山村
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
             <a href="https://jx.fsygroup.com/" target="_blank">jx.fsygroup.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website :  <a href="https://jx.fsygroup.com/" target="_blank">jx.fsygroup.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站: <a href="https://jx.fsygroup.com/" target="_blank">jx.fsygroup.com</a>
            </div>
        </el-card>
        </div>
        
       <div  class="card-left2_m">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">梅岭世纪园</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Meiling Century Park</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">梅嶺世紀園</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 400-607-9178
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 400-607-9178
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 400-607-9178
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址:江西省南昌市新建区七彩路东
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address :East of Qicai Road, Xinjian District, Nanchang City, Jiangxi Province
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址:江西省南昌市新建區七彩路東
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
             <a href="https://jx.fsygroup.com/" target="_blank">jx.fsygroup.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website : <a href="https://jx.fsygroup.com/" target="_blank">jx.fsygroup.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站: <a href="https://jx.fsygroup.com/" target="_blank">jx.fsygroup.com</a>
            </div>
        </el-card>
        </div>

       <div  class="card-left2_m">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">赣州蓉龙人文纪念园</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Ganzhou Ronglong Humanistic Memorial Park</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">贛州蓉龍人文紀念園</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 400-830-1448
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 400-830-1448
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 400-830-1448
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址: 江西省赣州蓉江新区潭东镇茶元村
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address : Chayuan Village, Tandong Town, Rongjiang New District, Ganzhou, Jiangxi Province
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址: 江西省贛州蓉江新區潭東鎮茶元村
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
             <a href="https://jxgz.fsygroup.com/" target="_blank">jxgz.fsygroup.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website : <a href="https://jxgz.fsygroup.com/" target="_blank">jxgz.fsygroup.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站: <a href="https://jxgz.fsygroup.com/" target="_blank">jxgz.fsygroup.com</a>d
            </div>
        </el-card>
        </div>

        </div>
         <!--5-->
        <div class="ListCard">
         <div  class="card-left1_m">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">淮北福寿园</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Huaibei Fushou Garden</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">淮北福壽園</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 0561-3080408
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 0561-3080408
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 0561-3080408
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址:安徽省淮北市杜集区方山路 
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address :Fangshan Road, Duji District, Huaibei City, Anhui Province
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址:安徽省淮北市杜集區方山路
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
             <a href="http://www.huaibeifsy.com/" target="_blank">www.huaibeifsy.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website :<a href="http://www.huaibeifsy.com/" target="_blank">www.huaibeifsy.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站:<a href="http://www.huaibeifsy.com/" target="_blank">www.huaibeifsy.com</a>
            </div>
        </el-card>
        </div>
        
       <div  class="card-left2_m">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">宿州龙门福寿园</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Suzhou Longmen Fushou Garden</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">宿州龍門福壽園</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 400-612-2808
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 400-612-2808
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話:400-612-2808 
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址:宿州市埇桥区符离镇褚庄村北800米（206国道旁）
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address :800 meters north of Chuzhuang Village, Fuli Town, Yongqiao District, Suzhou City (next to National Highway 206)
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址:宿州市埇橋區符離鎮褚莊村北800米（206國道旁
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website :
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站:
            </div>
        </el-card>
        </div>

       <div  class="card-left2_m">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">宣城马山风景陵园</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Xuancheng Mashan Scenic Cemetery</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">宣城馬山風景陵園</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 0563-2022586
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 0563-2022586
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 0563-2022586
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址:宣城市宣州区养贤乡大山庵村 
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address :Dashan'an Village, Yangxian Township, Xuanzhou District, Xuancheng City
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址:宣城市宣州區養賢鄉大山庵村
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
           
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website :  
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站: 
            </div>
        </el-card>
        </div>

        </div>
         <!--6-->
        <div class="ListCard">
         <div  class="card-left1_m">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">湖北天圣园</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Hubei Tiansheng Garden</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">湖北天聖園</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 0728-4586144
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 0728-4586144
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 0728-4586144
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址:湖北省天门市多祥镇天门南站旁900米
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address :900 meters away from Tianmen South Station, Duoxiang Town, Tianmen City, Hubei Province
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址:湖北省天門市多祥鎮天門南站旁900米
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
             <a href="http://www.fsytsy.com" target="_blank">www.fsytsy.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website :<a href="http://www.fsytsy.com" target="_blank">www.fsytsy.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站:<a href="http://www.fsytsy.com" target="_blank">www.fsytsy.com</a>
            </div>
        </el-card>
        </div>
        
       <div  class="card-left2_m">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">合肥人本殡葬服务</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Hefei Humanistic Funeral Services</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">合肥人本殯葬服務</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 0551-962444
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 0551-962444
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 0551-962444
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址:安徽省合肥市蜀山区合作化北路153号殡仪馆宿舍F区301 
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address:Room 301, Block F, Funeral Parlor Dormitory, No. 153 Hezuo North Road, Shushan District, Hefei City, Anhui Province
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址:安徽省合肥市蜀山區合作化北路153號殯儀館宿舍F區301
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站:<a href="http://www.hfrbbz.com" target="_blank">www.hfrbbz.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website :<a href="http://www.hfrbbz.com" target="_blank">www.hfrbbz.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站: <a href="http://www.hfrbbz.com" target="_blank">www.hfrbbz.com</a>
            </div>
        </el-card>
        </div>

       <div  class="card-left2_m">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">瑞昌福寿礼仪</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Ruichang Blessing and Longevity Etiquette</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">瑞昌福壽禮儀</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 0792-4232123
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 0792-4232123
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 0792-4232123
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址: 江西省九江市瑞昌市人民北路138号
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address :No. 138 Renmin North Road, Ruichang City, Jiujiang City, Jiangxi Province
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址: 江西省九江市瑞昌市人民北路138號
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website : 
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站: 
            </div>
        </el-card>
        </div>

        </div>
         <!--7-->
        <div class="ListCard">
         <div  class="card-left1_m">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">庐江福寿礼仪</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Lujiang Blessing and Longevity Etiquette</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">廬江福壽禮儀</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 0551-87771414
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 0551-87771414
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 0551-87771414
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址:安徽省庐江县庐城镇庐白路123号 
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address :No. 123 Lubai Road, Lucheng Town, Lujiang County, Anhui Province
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址:安徽省廬江縣廬城鎮廬白路123號
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website :
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站:
            </div>
        </el-card>
        </div>
        
       <div  class="card-left2_m">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">巢湖福寿礼仪</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Chaohu Blessing and Longevity Etiquette</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">巢湖福壽禮儀</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 0551-82323234
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 0551-82323234
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 0551-82323234
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址:安徽省巢湖市夏阁镇殷家山路1号
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address :No.1 Yinjiashan Road, Xiage Town, Chaohu City, Anhui Province
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址:安徽省巢湖市夏閣鎮殷家山路1號
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website :
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站:
            </div>
        </el-card>
        </div>

       <div  class="card-left2_m">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">舒城福寿礼仪</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Shucheng Blessing and Longevity Etiquette</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">舒城福壽禮儀</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话:0564-962444 
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 0564-962444
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 0564-962444
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址:安徽省六安市舒城县城关镇马河口镇幸福村舒城殡仪馆
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address :Shucheng Funeral Parlor, Xingfu Village, Mahekou Town, Chengguan Town, Shucheng County, Lu'an City, Anhui Province
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址:安徽省六安市舒城縣城關鎮馬河口鎮幸福村舒城殯儀館
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website :
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站:
            </div>
        </el-card>
        </div>

        </div>
         <!--8-->
        <div class="ListCard">
         <div  class="card-left1_m">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">兰州福寿园</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Lanzhou Fushou Garden</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">蘭州福壽園</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 0931-2345345
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone:0931-2345345
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 0931-2345345
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址: 兰州市七里河区沈家岭100号
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address :No. 100 Shenjialing, Qilihe District, Lanzhou City
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址:蘭州市七裡河區沈家嶺100號
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website :
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站: 
            </div>
        </el-card>
        </div>
        
       <div  class="card-left2_m">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">重庆白塔福寿园</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Chongqing Baita Fushou Garden</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">重慶白塔福壽園</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 023-49888888 
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 023-49888888
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 023-49888888
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址:重庆市永川区南大街新泰路269号 
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address :No. 269 Xintai Road, South Street, Yongchuan District, Chongqing
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址:重慶市永川區南大街新泰路269號
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
             <a href="https://cqyc.fsygroup.com/" target="_blank">cqyc.fsygroup.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website :  <a href="https://cqyc.fsygroup.com/" target="_blank">cqyc.fsygroup.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站:  <a href="https://cqyc.fsygroup.com/" target="_blank">cqyc.fsygroup.com</a>
            </div>
        </el-card>
        </div>

       <div  class="card-left2_m">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">重庆西郊福寿园</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Fushou Garden in the western suburbs of Chongqing</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">重慶西郊福壽園</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 400-860-1448 
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 400-860-1448 
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 400-860-1448
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址:重庆市璧山区河边镇复兴村3组 
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address :Group 3, Fuxing Village, Hebian Town, Bishan District, Chongqing City
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址:重慶市璧山區河邊鎮復興村3組
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
             <a href="http://www.cqxjfsy.com/" target="_blank">www.cqxjfsy.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website :  <a href="http://www.cqxjfsy.com/" target="_blank">www.cqxjfsy.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站:  <a href="http://www.cqxjfsy.com/" target="_blank">www.cqxjfsy.com</a>
            </div>
        </el-card>
        </div>

        </div>
         <!--9-->
        <div class="ListCard">
         <div  class="card-left1_m">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">重庆南山福座陵园</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Chongqing Nanshan Fuzuo Cemetery</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">重慶南山福座陵園</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 023-62752338
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 023-62752338
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 023-62752338
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址:重庆市南岸区四公里光黔路80号江南殡仪馆右侧
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address :Right side of Jiangnan Funeral Parlor, No. 80 Guangqian Road, Nan'an District, Chongqing
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址:重慶市南岸區四公里光黔路80號江南殯儀館右側
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
             <a href="https://cqns.fsygroup.com/" target="_blank">cqns.fsygroup.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website :  <a href="https://cqns.fsygroup.com/" target="_blank">cqns.fsygroup.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站:  <a href="https://cqns.fsygroup.com/" target="_blank">cqns.fsygroup.com</a>
            </div>
        </el-card>
        </div>
        
       <div  class="card-left2_m">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">钦州华祖园</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Qinzhou Huazu Garden</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">欽州華祖園</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 400-100-8911
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 400-100-8911
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 400-100-8911
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址: 钦州市钦北区大垌镇歌标村
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address :Gebiao Village, Dadong Town, Qinbei District, Qinzhou City
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址:欽州市欽北區大垌鎮歌標村
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
             <a href="https://gxqz.fsygroup.com/" target="_blank">gxqz.fsygroup.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website :  <a href="https://gxqz.fsygroup.com/" target="_blank">gxqz.fsygroup.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站:  <a href="https://gxqz.fsygroup.com/" target="_blank">gxqz.fsygroup.com</a>
            </div>
        </el-card>
        </div>

       <div  class="card-left2_m">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">广西华祖园</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Guangxi Huazu Garden</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">廣西華祖園</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 400-100-8911
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 400-100-8911
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 400-100-8911
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址:防城港市防城区三波村 
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address : Sanbo Village, Fangcheng District, Fangchenggang City
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址: 防城港市防城區三波村
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
             <a href="https://gxfcg.fsygroup.com/" target="_blank">gxfcg.fsygroup.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website :  <a href="https://gxfcg.fsygroup.com/" target="_blank">gxfcg.fsygroup.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站:  <a href="https://gxfcg.fsygroup.com/" target="_blank">gxfcg.fsygroup.com</a>
            </div>
        </el-card>
        </div>

        </div>
         <!--10-->
        <div class="ListCard">
         <div  class="card-left1_m">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">延安洪福公墓有限公司</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Yan'an Hongfu Cemetery Co., Ltd</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">延安洪福公墓有限公司</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 0911-8810777
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 0911-8810777
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 0911-8810777
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址:陕西省延安市宝塔区万花山镇前锁崖村归厚路后山 
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address :Behind Guihou Road, Qiansuoya Village, Wanhuashan Town, Baota District, Yan'an City, Shaanxi Province
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址:陝西省延安市寶塔區萬花山鎮前鎖崖村歸厚路後山
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website :
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站: 
            </div>
        </el-card>
        </div>
        
       <div  class="card-left2_m">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">金沙福寿园</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Jinsha Fushou Garden</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">金沙福壽園</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 0857-7212444
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 0857-7212444
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 0857-7212444
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址:贵州省毕节市金沙县五龙街道新光组大竹林南侧 
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address :South of Dazhulin, Xinguang Formation, Wulong Street, Jinsha County, Bijie City, Guizhou Province
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址:貴州省畢節市金沙縣五龍街道新光組大竹林南側
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
             <a href="https://gzjs.fsygroup.com/" target="_blank">gzjs.fsygroup.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website :  <a href="https://gzjs.fsygroup.com/" target="_blank">gzjs.fsygroup.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站:  <a href="https://gzjs.fsygroup.com/" target="_blank">gzjs.fsygroup.com</a>
            </div>
        </el-card>
        </div>

       <div  class="card-left2_m">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">正安福寿园</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Zheng'an Fushou Garden</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">正安福壽園</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 0851-28762777 
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 0851-28762777
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 0851-28762777
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址:贵州省遵义市正安县凤仪街道楼台村大山组
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address :Dashan Group, Loutai Village, Fengyi Street, Zheng'an County, Zunyi City, Guizhou Province
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址:貴州省遵義市正安縣鳳儀街道樓臺村大山組
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website :
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站:
            </div>
        </el-card>
        </div>

        </div>
         <!--11-->
        <div class="ListCard">
         <div  class="card-left1_m">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">重庆安乐生命纪念馆</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Chongqing Anle Life Memorial Hall</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">重慶安樂生命紀念館</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 400-023-8484 
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 400-023-8484 
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 400-023-8484
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址: 重庆市渝中区长滨路341号
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address : No. 341 Changbin Road, Yuzhong District, Chongqing
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址: 重慶市渝中區長濱路341號
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
             <a href="https://cq.fsygroup.com/" target="_blank">cq.fsygroup.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website :  <a href="https://cq.fsygroup.com/" target="_blank">cq.fsygroup.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站:  <a href="https://cq.fsygroup.com/" target="_blank">cq.fsygroup.com</a>
            </div>
        </el-card>
        </div>
        
       <div  class="card-left2_m">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">重庆新桥安乐堂</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Chongqing Xinqiao Anle Hall</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">重慶新橋安樂堂</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 400-023-8484
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 400-023-8484
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 400-023-8484
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址: 重庆沙坪坝区新桥村石壁山3号
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address :No.3 Shibishan, Xinqiao Village, Shapingba District, Chongqing
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址:重慶沙坪壩區新橋村石壁山3號
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
             <a href="https://cq.fsygroup.com/" target="_blank">cq.fsygroup.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website :  <a href="https://cq.fsygroup.com/" target="_blank">cq.fsygroup.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站:  <a href="https://cq.fsygroup.com/" target="_blank">cq.fsygroup.com</a>
            </div>
        </el-card>
        </div>

       <div  class="card-left2_m">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">辽宁观陵山福寿园</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Liaoning Guanling Mountain Fushou Garden</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">遼寧觀陵山福壽園</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 400-886-1448 
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 400-886-1448 
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 400-886-1448
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址:辽宁省铁岭市铁岭县横道河子镇 
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address :Hengdaohezi Town, Tieling County, Tieling City, Liaoning Province
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址:遼寧省鐵嶺市鐵嶺縣橫道河子鎮
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
             <a href="http://www.gls024.com" target="_blank">www.gls024.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website :  <a href="http://www.gls024.com" target="_blank">www.gls024.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站:  <a href="http://www.gls024.com" target="_blank">www.gls024.com</a>
            </div>
        </el-card>
        </div>

        </div>
         <!--12-->
        <div class="ListCard">
         <div  class="card-left1_m">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">哈尔滨福寿园</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Harbin Fushou Garden</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">哈爾濱福壽園</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 400-055-7058
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 400-055-7058
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 400-055-7058
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址:黑龙江省哈尔滨市宾县二龙山
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address :Erlongshan Mountain, Bin County, Harbin City, Heilongjiang Province
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址:黑龍江省哈爾濱市賓縣二龍山
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
             <a href="https://hrb.fsygroup.com/" target="_blank">hrb.fsygroup.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website :  <a href="https://hrb.fsygroup.com/" target="_blank">hrb.fsygroup.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站:  <a href="https://hrb.fsygroup.com/" target="_blank">hrb.fsygroup.com</a>
            </div>
        </el-card>
        </div>
        
       <div  class="card-left2_m">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">锦州帽山福寿园</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Jinzhou Maoshan Fushou Garden</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">錦州帽山福壽園</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 400-004-8099
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 400-004-8099
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 400-004-8099
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址: 辽宁省锦州市古塔区钟屯乡帽山村南
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address :Maoshan Village South, Zhongtun Township, Guta District, Jinzhou City, Liaoning Province
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址:遼寧省錦州市古塔區鐘屯鄉帽山村南
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
             <a href="https://lnjz.fsygroup.com" target="_blank">lnjz.fsygroup.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website :  <a href="https://lnjz.fsygroup.com" target="_blank">lnjz.fsygroup.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站:  <a href="https://lnjz.fsygroup.com" target="_blank">lnjz.fsygroup.com</a>
            </div>
        </el-card>
        </div>

       <div  class="card-left2_m">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">内蒙古福寿园</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Inner Mongolia Fushouyuan</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">內蒙古福壽園</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 0471-7260111
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 0471-7260111
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 0471-7260111
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址: 内蒙古呼和浩特市盛乐经济园区保尔此老村
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address :Baoerqi Old Village, Shengle Economic Park, Hohhot City, Inner Mongolia
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址:內蒙古呼和浩特市盛樂經濟園區保爾此老村
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
             <a href="http://www.nmgfsy.com/" target="_blank">www.nmgfsy.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website :  <a href="http://www.nmgfsy.com/" target="_blank">www.nmgfsy.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站:  <a href="http://www.nmgfsy.com/" target="_blank">www.nmgfsy.com</a>
            </div>
        </el-card>
        </div>

        </div>
         <!--13-->
        <div class="ListCard">
         <div  class="card-left1_m">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">朝阳龙山福寿园</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Chaoyang Longshan Fushou Garden</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">朝陽龍山福壽園</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 0421-2578399
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 0421-2578399
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 0421-2578399
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址:朝阳县柳城街道波赤村
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address :Bochi Village, Liucheng Street, Chaoyang County
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址:朝陽縣柳城街道波赤村
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
             <a href="http://www.cyxlsfy.com" target="_blank">www.cyxlsfy.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website :<a href="http://www.cyxlsfy.com" target="_blank">www.cyxlsfy.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站:<a href="http://www.cyxlsfy.com" target="_blank">www.cyxlsfy.com</a>
            </div>
        </el-card>
        </div>
        
       <div  class="card-left2_m">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">涿鹿元宝山</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Zhuolu Yuanbao Mountain</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">涿鹿元寶山</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 15011597118 
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 15011597118
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 15011597118
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址:河北省张家口市涿鹿县卧佛寺镇太平堡村 
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address :Taipingbao Village, Wofosi Town, Zhuolu County, Zhangjiakou City, Hebei Province
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址:河北省張家口市涿鹿縣臥佛寺鎮太平堡村
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website :
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站:
            </div>
        </el-card>
        </div>

       <div  class="card-left2_m">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">沈阳福佑礼仪</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Shenyang Fuyou Etiquette</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">瀋陽福佑禮儀</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 400-609-6144
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 400-609-6144
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 400-609-6144
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址:辽宁省沈阳市浑南区孙家寨路99号
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address :No. 99 Sunjiazhai Road, Hunnan District, Shenyang City, Liaoning Province
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址:遼寧省瀋陽市渾南區孫家寨路99號
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website :
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站:  
            </div>
        </el-card>
        </div>

        </div>
         <!--14-->
        <div class="ListCard">
         <div  class="card-left1_m">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">河南福寿园</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Henan Fushouyuan</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">河南福壽園</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 400-666-3453
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 400-666-3453
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 400-666-3453
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址:河南省郑州市新郑龙湖镇双梅路1号
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address : No.1 Shuangmei Road, Longhu Town, Xinzheng, Zhengzhou City, Henan Province
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址: 河南省鄭州市新鄭龍湖鎮雙梅路1號
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
            <a href="https://hn.fsygroup.com/" target="_blank">hn.fsygroup.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website :<a href="https://hn.fsygroup.com/" target="_blank">hn.fsygroup.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站:<a href="https://hn.fsygroup.com/" target="_blank">hn.fsygroup.com</a>
            </div>
        </el-card>
        </div>
        
       <div  class="card-left2_m">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">山东福寿园</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Shandong Fushouyuan</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">山東福壽園</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 400-658-6779
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 400-658-6779
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 400-658-6779
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址:山东省济南市长清区孝里街道龙泉官庄村南
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address : South of Longquan Guanzhuang Village, Xiaoli Street, Changqing District, Jinan City, Shandong Province
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址: 山東省濟南市長清區孝裏街道龍泉官莊村南
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
             <a href="http://www.sdfsy.com" target="_blank">www.sdfsy.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website :<a href="http://www.sdfsy.com" target="_blank">www.sdfsy.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站: <a href="http://www.sdfsy.com" target="_blank">www.sdfsy.com</a>
            </div>
        </el-card>
        </div>

       <div  class="card-left2_m">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">洛阳仙鹤福寿园</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Luoyang Xianhe Fushou Garden</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">洛陽仙鶴福壽園</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 400-811-8986
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 400-811-8986
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 400-811-8986
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址: 河南省洛阳市伊川县河滨街道办事处小庄社区168号
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address : No. 168, Xiaozhuang Community, Hebin Street Office, Yichuan County, Luoyang City, Henan Province
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址: 河南省洛陽市伊川縣河濱街道辦事處小莊社區168號
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
             <a href="https://ly.fsygroup.com/" target="_blank">ly.fsygroup.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website :  <a href="https://ly.fsygroup.com/" target="_blank">ly.fsygroup.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站:  <a href="https://ly.fsygroup.com/" target="_blank">ly.fsygroup.com</a>
            </div>
        </el-card>
        </div>

        </div>
         <!--15-->
        <div class="ListCard">
         <div  class="card-left1_m">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">安阳福寿园</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Anyang Fushou Garden</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">安陽福壽園</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 0372-5563444
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 0372-5563444
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 0372-5563444
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址:河南省安阳市殷都区洪河屯乡西五龙沟村 
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address :Xiwulonggou Village, Honghetun Township, Yindu District, Anyang City, Henan Province
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址:河南省安陽市殷都區洪河屯鄉西五龍溝村
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
             <a href="https://hnay.fsygroup.com/" target="_blank">hnay.fsygroup.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website :  <a href="https://hnay.fsygroup.com/" target="_blank">hnay.fsygroup.com</a>
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站:  <a href="https://hnay.fsygroup.com/" target="_blank">hnay.fsygroup.com</a>
            </div>
        </el-card>
        </div>
        
       <div  class="card-left2_m">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">泰安福寿礼仪</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Tai'an Blessing and Longevity Etiquette</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">泰安福壽禮儀</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 0538-8578144
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 0538-8578144
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 0538-8578144
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址:山东省泰安市岱岳区粥店办事处六郎坟村西
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address :West of Liulangfen Village, Congee Office, Daiyue District, Tai'an City, Shandong Province
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址: 山東省泰安市岱岳區粥店辦事處六郎墳村西
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website : 
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站:
            </div>
        </el-card>
        </div>

       <div  class="card-left2_m">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">菏泽福寿园</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Heze Fushou Garden</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">菏澤福壽園</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 0530-6264466
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 0530-6264466
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 0530-6264466
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址:菏泽市鲁西新区吕陵镇政府以西1.5公里 
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address :1.5 kilometers west of Luling Town Government in Luxi New District, Heze City
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址:菏澤市魯西新區呂陵鎮政府以西1.5公里
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website :
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站:
            </div>
        </el-card>
        </div>

        </div>
         <!--16-->
        <div class="ListCard">
         <div  class="card-left1_m">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">安尊福寿园</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Anzhun Fushou Garden</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">安尊福壽園</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 0534-5953888
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 0534-5953888
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 0534-5953888
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址:山东省德州市齐河县华店镇齐河人文纪念公园东400米
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address :400 meters east of Qihe Humanistic Memorial Park, Huadian Town, Qihe County, Dezhou City, Shandong Province
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址:山東省德州市齊河縣華店鎮齊河人文紀念公園東400米
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website : 
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站: 
            </div>
        </el-card>
        </div>
        
       <div  class="card-left2_m">
        <el-card class="box-card">
           <div slot="header" class="clearfix" v-if="Language==1">
           <span class="bt_title">郑州福寿礼仪</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==2">
           <span class="bt_title">Zhengzhou Fushou Etiquette</span>
           </div>
            <div slot="header" class="clearfix" v-if="Language==3">
           <span class="bt_title">鄭州福壽禮儀</span>
           </div>
           <div class="text item nr_text" v-if="Language==1">
            电话: 400-666-3443
            </div>
            <div class="text item nr_text" v-if="Language==2">
            Telephone: 400-666-3443
            </div>
            <div class="text item nr_text" v-if="Language==3">
            電話: 400-666-3443
            </div>
            <div class="text item nr_text" v-if="Language==1">
            地址:河南省郑州市中原区西三环与航海路交叉口向南600米路西
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Address : 600 meters south of the intersection of West Third Ring Road and Hanghai Road in Zhongyuan District, Zhengzhou City, Henan Province, west of the road
            </div>
              <div class="text item nr_text" v-if="Language==3">
            地址: 河南省鄭州市中原區西三環與航海路交叉口向南600米路西
            </div>
             <div class="text item nr_text" v-if="Language==1">
            网站: 
            </div>
              <div class="text item nr_text" v-if="Language==2">
            Website : 
            </div>
              <div class="text item nr_text" v-if="Language==3">
            網站:  
            </div>
        </el-card>
        </div>

        </div>
        </div>

        </div>



      </div>
    </div>


  </div>
  
</template>

<script>
export default {
  name: 'noticePage',
  data(){
    return{
      type: 'list',
      list: [],
      currentPage: 1,
      imgBaseUrl: '',
      id: '',
      detail: {},
      isshow:false,
      terminal: 'PC',
       Language:'',
    }
  },
  mounted(){
    this.terminal = localStorage.getItem('terminal')
    this.imgBaseUrl = localStorage.getItem('imgBaseUrl')
     this.Language= localStorage.getItem('Language');
    this.getList()
  },
  methods:{
    toDownload(item){
      let url = this.imgBaseUrl + item.Content
      window.open(url,'_blank')
    },
    toDetail(item){
      this.type = 'detail'
      this.id = item.ID
    },
    getList(){
      let that = this
      let params = {
        Language: localStorage.getItem('Language') || 1
      }
      that.$axios.post(this.baseURL + "api/Web_ContactUs/GetPageDataV1",params).then(
        (res) => {
          that.detail = res.data.rows[0]
          that.isshow=true
        },
        (error) => {
          console.log("请求失败了", error.message);
      });
    }
  }
}
</script>

<style scoped lang="scss">
.grop-news{
  min-height: 3600px;
}
.bt_title
{
  font-size: 20px;
}
.nr_text
{
  font-size: 13px;
}
.card-left1{
   float: left; width: 415px;
  }
.card-left2{
   float: left;width: 415px;
   margin-left: 15px;
 }
 .box-card
 {
  margin-bottom: 15px;
 }
 .ListCard{
  clear: both;
 }
</style>